<template>
  <div class="">
    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
    >

      <div id="logoContainer" style="height: 65px; text-align: center; background-color: #1D3662!important; padding: 5px 0px;">
          <a href="/"><img class="logo" src="@/assets/images/tramite/signathor-white.webp" alt="Logo" style="height: 45px; margin-top: 4px;"></a>
      </div>

      <div id="certificado-body" class="div-with-loading vs-con-loading__container">
          <h2 style="width: fit-content; margin: 20px auto; font-weight:bold; font-size: 18px; text-align: center;"><b>{{cert_data.tramite.codigo}}</b></h2>
          <div v-if="cert_data.tramite.pagado" class="main-container">
              <div class="certificado-container">
                  <PDFViewer ref="pdfViewer" :urlProp="cert_url" :singlePageProp="true"></PDFViewer>
              </div>
              <div class="certificado-detalles">
                  <table>
                      <tr>
                          <td>Nombre del Trámite</td>
                          <td style="text-align: right;"><b>{{cert_data.tramite.nombre}}</b></td>
                      </tr>
                      <tr>
                          <td>Fecha Creación</td>
                          <td style="text-align: right;">{{cert_data.tramite.fecha_creacion}}</td>
                      </tr>
                      <tr>
                          <td>Número de Documentos</td>
                          <td style="text-align: right;">{{cert_data.documentos}}</td>
                      </tr>
                      <tr>
                          <td>Número de Firmas</td>
                          <td style="text-align: right;">{{cert_data.controles}}</td>
                      </tr>
                      <tr>
                          <td>Número de Firmantes</td>
                          <td style="text-align: right;">{{cert_data.firmantes}}</td>
                      </tr>
                      <tr v-if="cert_data.tramite.permitir_descargar_archivos_en_certificado">
                          <td>Descargar Archivos</td>
                          <td style="text-align: right;">
                              <b-button class="sm:w-auto sm:order-normal order-3 sm:mt-0" @click="showModal()" variant="warning"><font-awesome-icon icon="download"/></b-button>
                          </td>
                      </tr>
                  </table>
                  <b-button class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-1" @click="genCert()" variant="primary"><font-awesome-icon icon="file-pdf"/>  Descargar Certificado</b-button>
              </div>
          </div>
          <div v-else class="main-container">
            <b-alert class="cw-alert" variant="info" icon-pack="feather" icon="icon-info" style="margin-top: 100px; ">
              Para acceder al certificado debe realizar el pago correspondiente al trámite.
            </b-alert>
          </div>
      </div>

      <b-modal
        ref="modal-descarga-archivos"
        id="modal-descarga-archivos"
        modal-class="modal-primary"
        centered
        title="Descarga de archivos"
        @hidden="limpiarCamposModal()"
      >
        <div class="con-exemple-prompt">
          <label class="text-sm"><span class="text-danger">*</span> PIN</label>
          <b-input
              label="PIN"
              type="password"
              placeholder="Ingrese el PIN"
              v-model="pinDescarga"
              v-validate="'required'"
              :danger="errors.has('PIN')"
              name="PIN"
              maxlength="6"
              class="w-full" />
          <span class="text-danger text-sm"  v-show="errors.has('PIN')">{{  errors.first('PIN') }}</span>
        </div>

        <template #modal-footer>
          <div style="display:flex; width: fit-content; margin: auto;" class="mt-1">
              <b-button @click="submitFormPinDescarga()" variant="primary">Enviar</b-button>
          </div>
        </template>
      </b-modal>
    </b-overlay>
  </div>
</template>


<script>
import axios from '@/axios';
import download from 'downloadjs'
import PDFViewer from '../../tramite/DocumentoControles/PDFViewer.vue'
import rutasjson from "@/assets/utils/rutas.json"

import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
Validator.localize("es", es);

export default {
  data () {
    return {
      tramite: {
          token: null,
          nombre: null,
      },
      cert_data:{
          tramite:{}
      },
      certificado: {},
      cert_url: '',

      pinDescarga: "",
      promptNewInt: false,
      mostrarLoader: false,

    }
  },
  mounted(){
    this.openLoadingInDiv()
    this.cert_url = rutasjson.axios+'api/tramite/certificado/?token='+String(this.$route.params.token)
    axios.get('api/tramite/get-certificado/',{params:{token: String(this.$route.params.token)}}).then(
      response => {
        this.cert_data = response.data
        // console.log(this.cert_data)
        this.closeLoadingInDiv()
      }
    )
  },
  methods:{
      genCert(){
        this.openLoadingInDiv()
        axios.get('api/tramite/certificado/', {params:{token: String(this.$route.params.token)}}).then( response => {
            this.closeLoadingInDiv()
                const content = response.headers['content-type'];
                download(response.data, 'Certificado ' + String(this.cert_data.tramite.codigo), content);
            }
            );
      },

      limpiarCamposModal(){
          this.pinDescarga=""
      },

      submitFormPinDescarga(){
          this.$validator.validateAll().then(result => {
              if (result) {
                // if form have no errors
                this.sendPin()
              }
          });
      },

      sendPin(){
          var pinDescarga = this.pinDescarga
          var tokenTramite = this.cert_data.tramite.token
          this.openLoadingInDiv()
          this.promptNewInt = false;
          axios.post('api/tramite/verificar_pin_descarga/', {
              pin_descarga: pinDescarga,
              token_tramite: tokenTramite
          }).then(response => {
              if(response.data.status=='success'){
                  this.descargarArchivos(pinDescarga, tokenTramite);
              }else{
                  this.$swal({
                    title: 'Error!',
                    text: response.data.message,
                    icon: 'error',
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                    confirmButtonText: 'Aceptar',
                  })
              }
              this.closeLoadingInDiv()
          });
          this.limpiarCamposModal();
      },

      descargarArchivos(pinDescarga, tokenTramite){
          this.openLoadingInDiv()
          axios.post('api/tramite/descargar_archivos_con_pin/', {
              pin_descarga: pinDescarga,
              token_tramite: tokenTramite
          },{
              responseType: 'blob'
          }).then(response => {
                this.hideModal("modal-descarga-archivos")
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', String(this.cert_data.tramite.codigo) + '.zip');
                document.body.appendChild(link);
                link.click()
                this.closeLoadingInDiv()
          });
      },

      openLoadingInDiv(){
        this.mostrarLoader = true
      },

      closeLoadingInDiv(){
        this.mostrarLoader = false
      },

      showModal(){
          this.promptNewInt = true
          this.$bvModal.show("modal-descarga-archivos")
      },

      hideModal(id){
          this.promptNewInt = false
          this.$refs[id].hide()
      },
  },
  components:{
      PDFViewer
  }
}
</script>

<style scoped>
#certificado-body{
    padding: 0px 12px 30px 0px;
}

.main-container{
    display: flex;
    width: 70%;
    margin: auto;
}

.not-data-table.vs-table--not-data{
  display: none !important;
}

.certificado-container{
    width: 40%;
    margin: auto;
}

.certificado-detalles{
    width: 60%;
    text-align: center;
    font-size: 15px;
    padding: 5% 5%;
    margin: auto;
}

.certificado-detalles table{
    margin-bottom: 20px
}

@media only screen and (max-width: 900px) {
    .main-container{
        display: block;
        width: 90%;
        margin: auto;
    }

    .certificado-detalles{
        width: 90%;
    }
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>

<style>
.certificado-container #canvas-container canvas{
    min-height: auto !important;
}
</style>
